<template>
  <iframe
    :src="`${termsAndConditionsUrl}`"
    style="width: 100%; height: 500px"
    frameborder="0"
  ></iframe>
</template>
<script>
  import appConfig from '@/config/app.js';
  export default {
    name: 'termsAndConditionsTemplate',
    data() {
      return {
        termsAndConditionsUrl: appConfig.termsAndConditionsUrl,
      };
    },
  };
</script>
